export default __webpack_public_path__ + "static/media/preview-course(2).67664109.png";